import { createUseFetcher, getGraphqlRequestClient } from '@brighte/passwordless-authenticator';

export const useFetcher = createUseFetcher(import.meta.env.VITE_GRAPHQL_URL);

export const hygraphRequest = (options?: RequestInit['headers']) => {
  return getGraphqlRequestClient(import.meta.env.VITE_HYGRAPH_URL, {
    headers: {
      ...options,
      Authorization: `Bearer ${import.meta.env.VITE_HYGRAPH_TOKEN}`,
    },
  });
};
